import React from 'react';
import * as _ from 'lodash';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Cell,
  LabelList,
  XAxis,
} from 'recharts';
import { ChartDataMeter } from '../../interfaces';
import Styled from './ChartBarsMeter.style';
import { useTranslation } from 'react-i18next';
import { prettifyIfNumber } from '../../helpers/helpers';

interface ChartBars2Props {
  id: number;
  chartData: ChartDataMeter;
  title: string;
  theme?: string;
}

const ChartBarsMeter: React.FC<ChartBars2Props> = (props) => {
  const { chartData } = props;
  const [t] = useTranslation('common');

  const transformedData = chartData.dataSets.use?.data;

  const yLabels = chartData.dataSets.use?.yLabel;

  const renderCustomizedLabel = (props) => {
    const { x, y, height, width, value } = props;
    const radius = 10;
    return (
      <text
        x={x + width / 2}
        y={y - radius}
        width={width}
        height={height}
        fill="#0F3E5D"
        style={{ fontWeight: 700 }}
        textAnchor="middle"
      >
        <tspan x={x + width / 2} dy="0em">
          {prettifyIfNumber(value)}
        </tspan>
      </text>
    );
  };

  const getYlabels = () => {
    return yLabels && t(yLabels);
  };

  const geXlabels = () => {
    return '22';
  };

  return (
    <Styled.Wrap>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <Styled.VerticalLine>
          <p
            style={{
              transform: 'rotate(270deg)',
              width: '70px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 0 26px 0',
            }}
          >
            {getYlabels()}
          </p>
        </Styled.VerticalLine>
        <div
          style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        >
          <ResponsiveContainer height={280} width="100%">
            <BarChart
              key={JSON.stringify(transformedData)}
              data={transformedData}
              height={400}
              margin={{
                top: 50,
                right: 0,
                bottom: 0,
                left: 0,
              }}
              barCategoryGap={40}
            >
              <Bar
                name="value"
                maxBarSize={60}
                barSize={60}
                radius={[4, 4, 0, 0]}
                dataKey="value"
                minPointSize={3}
                stackId="a"
                isAnimationActive={true}
                animationBegin={0}
                animationDuration={800}
              >
                <LabelList
                  dataKey="value"
                  content={renderCustomizedLabel}
                  position="top"
                />

                {transformedData?.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      index === 0
                        ? '#21AAE8'
                        : entry.value > transformedData[index - 1].value
                          ? '#f1b91a'
                          : '#4BAE50'
                    }
                  />
                ))}
              </Bar>

              <XAxis height={40} dataKey="label" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Styled.Wrap>
  );
};

export default ChartBarsMeter;
